import { render, staticRenderFns } from "./SelectBankModal.vue?vue&type=template&id=062f7283&"
import script from "./SelectBankModal.vue?vue&type=script&lang=js&"
export * from "./SelectBankModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports